export const getUserLocation = (longitude, latitude) => {
  return new Promise((resolve, reject) => {
    let geolocation = new BMapGL.Geolocation({
      // 是否使用高精度定位，默认：true
      enableHighAccuracy: true,
      // 设置定位超时时间，默认：无穷大
      timeout: 20000
    })
    geolocation.getCurrentPosition(
      (status) => {
        console.log(status, 'status')
        if (status && status.latitude) {
          let { latitude, longitude } = status
          // 创建地理编码实例, 并配置参数获取乡镇级数据
          var myGeo = new BMapGL.Geocoder({
            extensions_town: true
          })
          // 根据坐标得到地址描述
          myGeo.getLocation(new BMapGL.Point(longitude, latitude), function(res) {
            if (res) {
              console.log('定位地址', res)
              let { addressComponents } = res
              if (!!addressComponents.province && !!addressComponents.city && !!addressComponents.district) {
                resolve(res)
              } else {
                reject()
              }
            } else {
              reject()
            }
          })
        } else {
          reject()
        }
      },
      function(err) {
        reject()
      }
    )
  })
}
